import React from 'react'

export default function ProjectsHeading() {
	return (
		<div className="my-projects">
			<h2 className="my-projects-heading ">My Projects</h2>
		</div>
	)
}
